import { useParams } from 'react-router-dom'
import { parseStoredUser } from '../../utils/authSession'
import CalendarMainScreen from './calendar/CalendarMainScreen'
import EducationDashboardScreen from './education/EducationDashboardScreen'
import FinancialDashboardScreen from './financial/FinancialDashboardScreen'
import PersonalDashboardScreen from './personal/PersonalDashboardScreen'
import TeamDashboardScreen from './team/TeamDashboardScreen'

export default function DashboardScreen() {
  const { tab } = useParams()
  const { modules } = parseStoredUser()

  // ── Education ERP users get their dedicated dashboard ──────────────────────
  // When the URL is /dashboard (no tab) or explicitly /dashboard/education,
  // and the user holds the 'education' module, render the Education Dashboard.
  const isEducationUser = Array.isArray(modules) && modules.includes('education')
  const corpModules = ['bruno', 'nerve', 'bridge', 'loop']
  const hasCorpModule = corpModules.some((m) => modules?.includes(m))

  if (isEducationUser && !hasCorpModule && (!tab || tab === 'education')) {
    return <EducationDashboardScreen />
  }

  // ── Corporate / multi-suite users use tabbed dashboards ───────────────────
  if (tab === 'team') return <TeamDashboardScreen />
  if (tab === 'financial') return <FinancialDashboardScreen />
  if (tab === 'calendar') return <CalendarMainScreen />
  return <PersonalDashboardScreen />
}
